var collapsible_list_pair_rtlignore_default = {
  "container": "td2jH",
  "title": "_8BE-8",
  "viewerContainer": "_1MKDy",
  "titleContainer": "OX5ON",
  "content": "hnIzD",
  "expandIcon": "U2I9q",
  "dndIcon": "nINwK",
  "RTL": "le2nQ",
  "LTR": "SLWbL",
  "itemContainer": "CCt9P",
  "itemContainerViewer": "mz-ze",
  "mouseDown": "VFpNv",
  "innerEditor": "otYTO",
  "item": "y6y-8",
  "floatingAddPluginMenuWrapper": "_6SF-E"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
